import { useGetCultureIndexCulturesQuery } from 'services/api/Meteorology/Agro/CultureIndex';
import { useHandleRequestErrors } from 'utils/hooks';
import { ResponseError } from 'services/api/base';

export default function useCulture() {
  const { data, error } = useGetCultureIndexCulturesQuery();

  useHandleRequestErrors(error as ResponseError);

  return {
    cultures: data || [],
  };
}
